var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1C3.44772 1 3 1.44772 3 2V12C3 12.5523 3.44772 13 4 13H14C14.5523 13 15 12.5523 15 12V2C15 1.44772 14.5523 1 14 1H4ZM14 11C14 11.5523 13.5523 12 13 12H5C4.44772 12 4 11.5523 4 11V3C4 2.44772 4.44772 2 5 2H13C13.5523 2 14 2.44772 14 3V11ZM2.90319 14C2.40437 14 2 13.5956 2 13.0968V3.70711C2 3.5745 1.94732 3.44732 1.85355 3.35355C1.53857 3.03857 1 3.26165 1 3.70711V14.8014C1 14.9111 1.08893 15 1.19863 15H12.2929C12.7383 15 12.9614 14.4614 12.6464 14.1464C12.5527 14.0527 12.4255 14 12.2929 14H2.90319Z",
    fill: "#00B292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98284 3C6.80466 3 6.71543 3.21543 6.84142 3.34142L8.85858 5.35858C8.93668 5.43668 8.93668 5.56332 8.85858 5.64142L6.14142 8.35858C6.06332 8.43668 6.06332 8.56332 6.14142 8.64142L7.35858 9.85858C7.43668 9.93668 7.56332 9.93668 7.64142 9.85858L10.3586 7.14142C10.4367 7.06332 10.5633 7.06332 10.6414 7.14142L12.6586 9.15858C12.7846 9.28457 13 9.19534 13 9.01716V3.2C13 3.08954 12.9105 3 12.8 3H6.98284Z",
    fill: "#00B292"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/InvoiceIcon.efd46df0.svg";
export { ForwardRef as ReactComponent };